<div class="legend" [ngClass]="legendColor$ | async" [ngStyle]="style" [pTooltip]="title" [showDelay]="250" [escape]="false">
  {{ label }}
</div>
